<template>
  <v-list-tile-action :class="['hidden-sm-and-down']">
    <v-icon :size="size">{{ icon }}</v-icon>
  </v-list-tile-action>
</template>
<script>
export default {
  name: 'ChevronRight',
  props: {
    size: {
      type: String,
      required: false,
      default: '2em'
    },
    icon: {
      type: String,
      required: false,
      default: 'mdi-chevron-right'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chevron-right.vue